import { useEffect } from 'react';

export function Modal({
  title,
  children,
  onClose,
  label,
  wide = false,
}: {
  title: string;
  children: React.ReactNode;
  onClose: () => void;
  label: string;
  wide?: boolean;
}) {
  useEffect(() => {
    const onKey = (e: KeyboardEvent) => e.key === 'Escape' && onClose();
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [onClose]);
  return (
    <div
      className="fixed inset-0 z-50 grid place-items-center bg-black/30 p-4"
      role="dialog"
      aria-modal="true"
      aria-label={label}
    >
      <div
        className={`flex max-h-[calc(100dvh-2rem)] w-full flex-col rounded-xl bg-paper p-6 shadow-xl ${wide ? 'max-w-4xl' : 'max-w-md'}`}
      >
        <h2 className="shrink-0 text-base font-semibold">{title}</h2>
        {/* A tall dialog scrolls inside itself; the title stays in view. */}
        <div className="mt-4 grid min-h-0 gap-4 overflow-y-auto overscroll-contain">{children}</div>
      </div>
    </div>
  );
}
